import { mixin } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import ProgressMixin from 'client/store/mixins/ProgressMixin';
import SudoMixin, {
  addSudoFeaturesToState,
  processSudoBoundItems,
  resetSudoState,
} from 'client/store/mixins/SudoMixin';
import SystemGroupApi from 'client/api/v2/SystemGroupApi';

/**
 * Extend base class to add sudoer specific functionality for System Users.
 */
export class SystemGroupCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();

    mixin(module.actions, ProgressMixin.actions);

    mixin(module.actions, SudoMixin.actions);
    mixin(module.getters, SudoMixin.getters);
    mixin(module.mutations, SudoMixin.mutations);

    module.actions.fetchSystemGroupById = (...params) => this.fetchSystemGroupById(...params);

    module.mutations.RESET_COLLECTION = (...params) => this.RESET_COLLECTION(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------

  getInitialState() {
    const state = addSudoFeaturesToState(super.getInitialState());
    return state;
  }

  // Getters
  // --------------------------------------------------------------------------

  /**
   * Override method from base class to ignore applied filters when determining
   * whether the SystemGroups collection can be refreshed.
   */
  // eslint-disable-next-line class-methods-use-this
  canRefreshCollection(state = { features: { items: {} } }, getters = {}) {
    const { features } = state;
    const { boundItemsUrl, showBoundItems } = features;
    const { searchTerm } = features.items;
    const { getItemsToBind = [], getItemsToUnbind = {} } = getters;
    const hasSelectionChanged = getItemsToBind.length > 0 || getItemsToUnbind.length > 0;

    return !((boundItemsUrl && showBoundItems) || searchTerm || hasSelectionChanged);
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------
  fetchSystemGroupById = (_, { id }) => SystemGroupApi.fetchSystemGroupById(id);

  /**
   * After bound items are retrieved iterate through each one to set the sudoer
   * status of each bound item.
   */
  processBoundItems(context, boundItems) {
    super.processBoundItems(context, boundItems);
    processSudoBoundItems(context, boundItems);
  }

  // --------------------------------------------------------------------------
  // Mutations
  // --------------------------------------------------------------------------

  RESET_COLLECTION(state, payload) {
    super.RESET_COLLECTION(state, payload);

    if (!payload || (payload && !payload.soft)) {
      const initialState = this.getInitialState();
      resetSudoState(state, initialState);
    }
  }
}
export default new SystemGroupCollectionClass(SystemGroupApi, 'id', 'name').extractModule();
